import { pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { TRANSITION_DURATION_IN_MS } from '../constants';

export const image = css`
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  display: block;
  opacity: 0;
  transition: opacity ${TRANSITION_DURATION_IN_MS}ms;
  object-fit: cover;
  object-position: 50% 0;
  width: 100%;
  border-radius: ${pxToRem(10)};

  &[data-is-visible='true'] {
    opacity: 1;
  }
`;

export const placeholder = css`
  position: absolute;
  background-color: var(--neutral-black-70);
  width: 100%;
  height: 100%;
`;
